import React from "react";
import { RoundedToggleButton } from "@bloomberg/media-ui-core";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./styles.module.css";
import { useTranslateMessage } from "~utils/i18n";

interface SurveyToutProps {
  toutContent?: React.ReactNode;
  href: string;
  onClick?: () => void;
  buttonText?: string | null;
}

export const SurveyCallToActionTout = ({
  toutContent,
  href,
  onClick,
  buttonText = null,
}: SurveyToutProps) => {
  const translateMessage = useTranslateMessage();

  const resolvedButtonText =
    buttonText ??
    translateMessage({
      id: "surveyMsgButton",
      defaultMessage: "Take Survey",
    });

  return (
    <div className={styles.toutContainer}>
      <div className={styles.toutContent}>{toutContent}</div>
      <a href={href} target="_blank" rel="noreferrer">
        <RoundedToggleButton
          withIcon={false}
          onToggle={onClick}
          inactiveText={resolvedButtonText}
          activeText={resolvedButtonText}
          active={false}
        />
      </a>
    </div>
  );
};
